var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5886 0.744078C6.43232 0.587797 6.22036 0.5 5.99935 0.5C5.77834 0.5 5.56637 0.587797 5.41009 0.744078L0.410093 5.74408C0.0846564 6.06952 0.0846564 6.59715 0.410093 6.92259C0.73553 7.24803 1.26317 7.24803 1.5886 6.92259L5.99935 2.51184L10.4101 6.92259C10.7355 7.24803 11.2632 7.24803 11.5886 6.92259C11.914 6.59715 11.914 6.06952 11.5886 5.74408L6.5886 0.744078Z",
    fill: "#667185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5886 16.0893C6.43232 16.2455 6.22036 16.3333 5.99935 16.3333C5.77834 16.3333 5.56637 16.2455 5.41009 16.0893L0.410093 11.0893C0.0846564 10.7638 0.0846564 10.2362 0.410093 9.91074C0.73553 9.58531 1.26317 9.58531 1.5886 9.91074L5.99935 14.3215L10.4101 9.91074C10.7355 9.58531 11.2632 9.58531 11.5886 9.91074C11.914 10.2362 11.914 10.7638 11.5886 11.0893L6.5886 16.0893Z",
    fill: "#667185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpDown);
export default __webpack_public_path__ + "static/media/chevron-up-down.5d7dfdccf0d3154082ab8721c000e05e.svg";
export { ForwardRef as ReactComponent };